import React from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(2),
  },
}));

const TermsDialog = ({ open, handleClose, privacyPolicy }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={handleClose} scroll="paper" aria-labelledby="scroll-dialog-title">
      <DialogTitle id="scroll-dialog-title">
        {t(privacyPolicy ? 'terms_privacy_policy' : 'terms_of_service')}
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText>{t(privacyPolicy ? 'privacy_policy_body' : 'terms_of_service_body')}</DialogContentText>
      </DialogContent>
      <DialogActions className={classes.root}>
        <Button onClick={handleClose} color="primary">
          {t('OK')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

TermsDialog.propTypes = {
  open: PropTypes.bool,
  privacyPolicy: PropTypes.bool,
  handleClose: PropTypes.func,
};

TermsDialog.defaultProps = {
  open: false,
  privacyPolicy: false,
  handleClose: undefined,
};

export default TermsDialog;
